import {
  BankAccountGoalType,
  BankAccountType,
  PresentInvestmentsTotalsQueryQuery,
} from 'generated/types'
import { USDFormatterAutoRound } from 'utils/number/currency'

import { enabledRoutes } from '../enabledRoutes'

export const IS_EXIT_LEARN_TIP_SEEN = 'isExitSideNavLearnTipSeen'
export const HIDE_RERUN_SIDE_LEARNTIPS = 'hideRerunSideLearnTips'

export const calculateBankingHubValue = (
  investmentTotalData?: PresentInvestmentsTotalsQueryQuery,
) => {
  const allBankAccounts = investmentTotalData?.allBankAccounts

  const emergencyFundAccountBalance =
    allBankAccounts?.find(
      (bankAccount) =>
        bankAccount?.type === BankAccountType.Save &&
        bankAccount?.goals?.currentGoal?.type ===
          BankAccountGoalType.EmergencySavings,
    )?.availableBalance.value || 0

  const spendAccountBalance =
    allBankAccounts?.find(
      (bankAccount) => bankAccount?.type === BankAccountType.Spend,
    )?.availableBalance?.value || 0

  return spendAccountBalance || emergencyFundAccountBalance
    ? USDFormatterAutoRound(emergencyFundAccountBalance + spendAccountBalance)
    : ''
}

export const includesPath = (locString: string) =>
  enabledRoutes.some((elem) => {
    return new RegExp('^' + elem.replace('*', '.*') + '$').test(locString)
  })

export const isActivePath = (baseRoutes: string[], activePath: string) => {
  return baseRoutes.map((route) => activePath === route).includes(true)
}

export const isTitleAndBodyOfTypeString = (title: any, body: any) =>
  typeof title === 'string' && typeof body === 'string'
